import { Loader } from '@progress/kendo-react-indicators'
import classNames from 'classnames'
import React from 'react'

import { Breadcrumbs } from '~/components/elements/Breadcrumbs'
import { LoadingPanel } from '~/components/elements/LoadingPanel'
import { type Breadcrumb } from '~/routes/utils'
import { exists } from '~/utils'

import styles from './PageContainer.css'

type Section = 'content' | 'navigation'

const defaultNoPadSections: Section[] = []

export type PageContainerProps = {
  breadcrumbs: Breadcrumb[]
  children?: React.ReactNode
  'data-testid'?: string
  executing?: boolean
  loading?: boolean
  navigation?: React.ReactNode
  noPadSections?: Section[]
}

export const PageContainer = ({
  breadcrumbs,
  children,
  'data-testid': dataTestId = 'components-elements-page-container',
  executing,
  loading,
  navigation,
  noPadSections = defaultNoPadSections,
}: PageContainerProps) => (
  <div
    className={classNames(styles.root, {
      [styles.executing]: executing,
    })}
    data-testid={dataTestId}
  >
    <div
      className={classNames(styles.mainContainer, {
        [styles.mainContainerWithNavigation]: exists(navigation),
      })}
    >
      {!loading && (
        <div className={styles.breadcrumbsContainer}>
          <Breadcrumbs items={breadcrumbs} />
        </div>
      )}

      <div
        className={classNames(styles.contentContainer, {
          [styles.noPad]: noPadSections.includes('content'),
        })}
      >
        {loading ? <LoadingPanel /> : children}
      </div>
    </div>

    {!loading && navigation && (
      <div
        className={classNames(styles.navigationContainer, {
          [styles.noPad]: noPadSections.includes('navigation'),
        })}
      >
        {navigation}
      </div>
    )}

    {executing && (
      <Loader className={styles.executingLoader} type="infinite-spinner" />
    )}
  </div>
)
